import React, { useState, useEffect } from "react";
import { Camera, Link as LinkIcon, X, Plus } from "lucide-react";

export default function AdminPortfolio() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [data, setData] = useState([]);

  const [collection, setCollection] = useState([]);
  
  const [showCollectionFor, setShowCollectionFor] = useState(null);

  const [formData, setFormData] = useState({
    layout: "one",
    image_1:"",
    image_2: "",
    credit_1: "",
    credit_2: ""
  });

  useEffect(() => {
    fetchRows();
  }, []);

  useEffect(() => {
    if (showForm) {
      fetchCollection();
    }
  }, [showForm]);

  const fetchRows = async () => {
    const res = await fetch("/api/admin/medias/rows.php");
    const rows = await res.json();
    setData(rows);
  };

  const fetchCollection = async () => {
    const res = await fetch("/api/admin/assets/collection.php");
    const collection = await res.json();
    setCollection(collection);
  };

  async function handleSubmit(e) {
  e.preventDefault();

  const url = editingId
    ? "/api/admin/medias/edit_row.php"
    : "/api/admin/medias/add_row.php";

  const form = new FormData();
  form.append("layout", formData.layout);
  form.append("credit_1", formData.credit_1);
  form.append("credit_2", formData.credit_2);


// 🔥 Gestion propre des images
  ["image_1", "image_2"].forEach(field => {
    if (formData[field] instanceof File) {
      form.append(field, formData[field]);
    } else if (typeof formData[field] === "string" && formData[field]) {
      form.append(field, formData[field]);
    }
  });

  if (editingId) {
    form.append("id", editingId);
  }

  try {
    const res = await fetch(url, {
      method: "POST",
      body: form
    });

    if (!res.ok) throw new Error("Erreur sauvegarde");

    fetchRows();
    resetForm();
  } catch (err) {
    console.error(err);
    alert("Erreur upload");
  }
}

  function resetForm() {
    setShowForm(false);
    setEditingId(null);
    setFormData({
                                layout: "one",
                                image_1: "",
                                image_2: "",
                                credit_1: "",
                                credit_2: ""
    });
  }

  function editRow(row) {
    setFormData({
      layout: row.layout,
      image_1: row.image_1,
      image_2: row.image_2,
      credit_1: row.credit_1,
      credit_2: row.credit_2
    });

    setEditingId(row.id);
    setShowForm(true);
  }

  async function deleteRow(id) {
    if (!window.confirm("Supprimer ce projet ?")) return;

    try {
      await fetch("/api/admin/medias/delete_row.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });

      fetchRows();
    } catch (err) {
      console.error("Erreur suppression projet", err);
    }
  }

  async function moveRow(id, direction) {
  await fetch("/api/admin/medias/move_row.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, direction })
  });

  fetchRows();
}

  return (
      <section>
      <div>
                <div className="container-xl">
                  <div className="bg-white rounded shadow p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h1 className="cat-title h3 fw-bold text-dark d-flex align-items-center gap-2">
                          <Camera className="text-primary" />
                          Photos
                        </h1>
                        <p className="text-secondary mb-0">
                          Ajouter, modifier ou supprimer des photos
                        </p>
                        <button
                          onClick={() => {
                            setShowForm(!showForm);
                            if (showForm) {
                              setEditingId(null);
                              setFormData({
                                layout: "",
                                image_1: "",
                                image_2: "",
                                credit_1: "",
                                credit_2: ""
                              });
                            }
                          }}
                          className="btn btn-primary d-flex align-items-center gap-2 mt-2"
                        >
                          <Plus size={20} />
                          Ajouter une ligne
                        </button>
                      </div>
                    </div>
                  {showForm && (
                    <div className="bg-primary bg-opacity-10 p-4 rounded mt-4 w-100">
                      <h3 className="fw-semibold mb-3">
                        {editingId ? "Modifier la ligne" : "Nouvelle ligne"}
                      </h3>
      
                      <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor="layout">
                                    Type de ligne
                                </label>

                                <select
                                    className="form-select"
                                    value={formData.layout}
                                    name="layout"
                                    required
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        setFormData({
                                            ...formData,
                                            layout: value,
                                            image_2: value === "two" ? formData.image_2 : ""
                                        });
                                    }}
                                >
                                    <option value="one">1 Photo</option>
                                    <option value="two">2 Photos</option>
                                </select>
                                </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='img1'>Image</label>
                                <input
                                  className="form-control"
                                  type="file"
                                  accept="image/*"
                                  name="image_1"
                                  onChange={(e)=> setFormData({...formData, image_1: e.target.files[0]})}
                                />
                                <button
                                  type="button"
                                  className="btn
                                   btn-sm col-6 btn-outline-primary mt-2"
                                  onClick={() => setShowCollectionFor("image_1")}
                                >
                                  Collection
                                </button>
                                <div>
                                  <label className="form-label fw-medium mt-2" htmlFor='credit_1'>Crédit photo</label>
                                  <input className="form-control" type='text' value={formData.credit_1} name='credit_1' required onChange={(e)=> setFormData({...formData, credit_1: e.target.value})}>
                                  </input>
                                  {/* Image existante */}
                                  {typeof formData.image_1 === "string" && formData.image_1 && (
                                    <img
                                      src={formData.image_1}
                                      alt="preview"
                                      style={{ width: "200px", marginTop: "10px" }}
                                    />
                                  )}

                                  {/* Nouvelle image */}
                                  {formData.image_1 instanceof File && (
                                    <img
                                      src={URL.createObjectURL(formData.image_1)}
                                      alt="preview"
                                      style={{ width: "200px", marginTop: "10px" }}
                                    />
                                  )}
                                </div>
                              {formData.layout === "two" && (
                                <div className="mt-2">
                                    <label className="form-label fw-medium" htmlFor='image_2'>Image 2</label>
                                    <input
                                    className="form-control"
                                    type="file"
                                    accept="image/*"
                                    name="image_2"
                                    onChange={(e) =>
                                        setFormData({ ...formData, image_2: e.target.files[0] })
                                    }
                                    />
                                    <button
                                      type="button"
                                      className="btn
                                      btn-sm col-6 btn-outline-primary mt-2"
                                      onClick={() => setShowCollectionFor("image_2")}
                                    >
                                      Collection
                                    </button>
                                    <div>
                                      <label className="form-label fw-medium mt-2" htmlFor='credit_2'>Crédit photo 2</label>
                                      <input className="form-control" type='text' value={formData.credit_2} name='credit_2' required onChange={(e)=> setFormData({...formData, credit_2: e.target.value})}></input>
                                      {/* Image existante */}
                                      {typeof formData.image_2 === "string" && formData.image_2 && (
                                      formData.image_2 && (
                                          <img
                                              src={formData.image_2}
                                              alt="preview"
                                              style={{ width: "100%", marginTop: "10px" }}
                                          />
                                          )
                                      )}

                                      {/* Nouvelle image */}
                                      {formData.image_2 instanceof File && (
                                      <img
                                          src={URL.createObjectURL(formData.image_2)}
                                          alt="preview"
                                          style={{ width: "200px", marginTop: "10px" }}
                                      />
                                      )}
                                    </div>
                                </div>
                                )}
                                </div>
                            </div>
      
                            <div className="d-flex gap-2 mt-4">
                              <button type="submit" className="btn btn-primary">
                                {editingId ? "Modifier" : "Enregistrer"}
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowForm(false);
                                  setEditingId(null);
                                  setFormData({
                                    layout: "",
                                    image_1: "",
                                    image_2: "",
                                    credit_1: "",
                                    credit_2: ""
                                  });
                                  setShowCollectionFor(null);
                                }}
                                className="btn btn-secondary"
                              >
                                Annuler
                              </button>
                            </div>
                          </form>
                        </div>
                      )}
                      {showCollectionFor && (
                        <div className="mt-4 p-3 border rounded bg-light">
                          <h5>Sélectionner une image</h5>

                          <div className="row">
                            {collection.map((img) => (
                              <div className="col-3 mb-3" key={img.id}>
                                <img
                                  src={img.image}
                                  alt=""
                                  style={{ width: "100%", cursor: "pointer" }}
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      [showCollectionFor]: img.image
                                    });
                                    setShowCollectionFor(null);
                                  }}
                                />
                              </div>
                            ))}
                          </div>

                          <button
                            type="button"
                            className="btn btn-secondary btn-sm mt-2"
                            onClick={() => setShowCollectionFor(null)}
                          >
                            Fermer
                          </button>
                        </div>
                      )}
                      <div className="col g-3 pt-4">
                        {data.map((row, i) => {
      
                          return (
                            <div className="col mb-3" key={row.id}>
                              <div className="card border-dark bg-white rounded shadow p-3 h-100">
                                <div className="border-bottom pb-2 mb-2">
                                  <div className="row mt-2">
                                    <div className={row.image_2 ? "col-6" : "col-12"}>
                                        <img
                                        src={row.image_1}
                                        alt="preview"
                                        className="img-fluid"
                                        />
                                        <p className="text-start mb-0 mt-1">@ {row.credit_1}</p>
                                    </div>

                                    {row.image_2 && (
                                        <div className="col-6">
                                        <img
                                            src={row.image_2}
                                            alt="preview"
                                            className="img-fluid"
                                        />
                                        <p className="text-start mb-0 mt-1">@ {row.credit_2}</p>
                                        </div>
                                    )}
                                    </div>
                                </div>
                                          <div className="d-flex gap-1">
                                            <button
                                              onClick={() => editRow(row)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Modifier"
                                            >
                                              Modifier
                                            </button>
                                            <button
                                              onClick={() => deleteRow(row.id)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Supprimer"
                                            >
                                              <X size={18} />
                                            </button>
                                            <button
                                              onClick={() => moveRow(row.id, "up")}
                                              className="btn btn-sm btn-outline-dark"
                                            >
                                              ↑
                                            </button>

                                            <button
                                              onClick={() => moveRow(row.id, "down")}
                                              className="btn btn-sm btn-outline-dark"
                                            >
                                              ↓
                                            </button>
                                          </div>
                                  </div>
                            </div>
                          );
                        })}
                      </div>
                  </div>
                </div>
              </div>
    </section>
  );
}